import { useQuery } from '@tanstack/react-query';
import { CASE_HIGH_LEVEL_STATUS_KEY } from '../../utils/constants/queryKeys';
import { getCaseHighLevelStatus } from '../services/fn-api/Cases';

export const useGetCaseHighLevelStatus = (caseId: number) => {
  return useQuery({
    queryKey: [CASE_HIGH_LEVEL_STATUS_KEY, caseId],
    queryFn: () => getCaseHighLevelStatus(caseId),
    enabled: !!caseId,
  });
};
